import * as Api from '@ViewModels';
import { useQuery } from '@tanstack/react-query';
import { useUserSession } from '../../models/hooks/appStateHooks';

const BASE_QUERY_KEY = '/website/<id>/anonymousUri';

export const useWebsiteAnonymousURIQuery = ({
	id,
	impersonationContext,
	enabled,
}: {
	id: string;
	impersonationContext?: Api.IImpersonationContext;
	enabled?: boolean;
}) => {
	const userSession = useUserSession();
	return useQuery({
		queryFn: () => {
			const data = userSession.webServiceHelper.callAsync<string>(
				Api.ImpersonationBroker.composeApiUrl({
					urlPath: `website/${id}/anonymousUri`,
					impersonationContext,
				}),
				'POST'
			);
			return data;
		},
		queryKey: [BASE_QUERY_KEY, id],
		enabled,
	});
};
